import React, { useState, useEffect, useRef } from "react";
import classes from "../BusinessEntityDetails.module.css";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import { ValidatorForm } from "react-material-ui-form-validator";
import InputField from "../../../components/ui/inputField";
import SelectField from "../../../components/ui/select";
import axios from "../../../axios-order";
import { toast } from "react-toastify";
import BoxWrapper from "../../../components/ui/boxWrapper";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RightDrawer from "../../../components/ui/RightDrawer";
import LinkIcon from "@mui/icons-material/Link";
import ValidatedDatePicker from "../../../components/ui/DatePicker";


const ConnectionDetails = (props) => {
  const formRef = useRef("form");
  const [connectionDetailTableData, setConnectionDetailTableData] = useState([]);
  const [editData, setEditData] = useState({});
  const [ediDataForIars, setEdiDataForIars] = useState({});
  const [addData, setAddData] = useState({});
  const [openAddConnectionDrawer, setOpenAddConnectionDrawer] = useState(false);
  const [openEditConnectionDrawer, setOpenEditConnectionDrawer] = useState(false);
  const [addSourceSystem, setAddSourceSystem] = useState("");
  const [iarsFormToShowInAddConnection, setIarsFormToShowInAddConnection] = useState(false);
  const [iarsFormToShowInEditConnection, setIarsFormToShowInEditConnection] = useState(false);
  const [zohoFormToShowInAddConnection, setZohoFormToShowInAddConnection] = useState(false);
  const [zohoFormToShowInEditConnection, setZohoFormToShowInEditConnection] = useState(false);
  const [editDataForZoho, setEditDataForZoho] = useState({});
  const [trueOrFalseForZoho, setTrueOrFalseForZoho] = useState(false);
  const [trueOrFalse, setTrueOrFalse] = useState(false);

  const getConnectionDetails = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status && Array.isArray(res.data.record)) {
          setConnectionDetailTableData(res.data.record);
        } else {
          console.error("Invalid response format:", res.data);
          setConnectionDetailTableData([]);
          toast.error(res.data.message || "No connection details found", {
            autoClose: 3000,
            progress: 0,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching connection details:", error);
        setConnectionDetailTableData([]);
        // toast.error(
        //   error.response?.data?.message || "Failed to connect to the server",
        //   {
        //     autoClose: 3000,
        //     progress: 0,
        //   }
        // );
      });
  };

  const handleEstablishConnection = () => {
    axios
      .get("/get_connection_url", {
        // params: {
        //   redirect_uri: `${window.location.origin}/BusinessEntityDetails/oauthorcard`,
        // },
      })
      .then((res) => {
        if (res.data && res.data.auth_url) {
          // window.open(res.data.auth_url, "_blank");
          window.location.href = res.data.auth_url;
        }
      })
      .catch((error) => {
        toast.error(
          error.response?.data?.message || "Failed to establish connection",
          { autoClose: 3000, progress: 0 }
        );
      });
  };

  useEffect(() => {
    // Temporary hardcoded data with top-level domain
    // setConnectionDetailTableData([
    //   {
    //     business_entity_id: 2191,
    //     source_system: "ZOHO",
    //     domain: ".in",
    //     connection_info: {
    //       code: "1000.bb8e8322998a743c9fe46a13f03153d3.067452bc09c88604557937924f90e6d3",
    //       client_id: "1000.2QJ2A6B5PWNG3IDV2TC0F4HAE5KZMF",
    //       access_token: "1000.c8a153067e0734840a06107c41d45760.ed75c8595da82aee85aac144123df9b4",
    //       client_secret: "1c317c0b4a94556b84276fb5d5598bf71291216f44",
    //       refresh_token: "1000.c6b3ccff7dcd1feedfe4afa952d72a88.f6f566aa09e3ecd1466f25a2b304c636",
    //       organisation_id: "60014280404",
    //     },
    //     date_created: "2025-05-21T19:47:51",
    //     date_modified: null,
    //     created_by: 1427,
    //     modified_by: null,
    //   },
    // ]);
    // Uncomment to fetch from API when ready
    getConnectionDetails();
  }, []);

  // connection table
  const connectionDetailTableBody = () => {
    const editConnectionData = (
      Port,
      access_token,
      company_code,
      Organisation_code,
      source_system,
      Hostname_IP,
      Username,
      Password,
      Company,
      License_Key,
      client_id,
      client_secret,
      organisation_id,
      code,
      domain,
      auto_sync,
      from_date,
      to_date
    ) => {
      if (source_system === "IARS") {
        setIarsFormToShowInEditConnection(true);
        setZohoFormToShowInEditConnection(false);
        setEdiDataForIars({
          source_system,
          Username,
          Password,
          Company,
          License_Key,
          Hostname_IP,
        });
      } else if (source_system === "ZOHO") {
        setZohoFormToShowInEditConnection(true);
        setIarsFormToShowInEditConnection(false);
        setEditDataForZoho({
          source_system,
          client_id,
          client_secret,
          organisation_id,
          code,
          domain: domain || ".in",
          auto_sync: auto_sync ? "Yes" : "No",
          from_date: from_date ? new Date(from_date) : "",
          to_date: to_date ? new Date(to_date) : ""
        });
      } else {
        setIarsFormToShowInEditConnection(false);
        setZohoFormToShowInEditConnection(false);
        setEditData({
          Port,
          access_token,
          company_code,
          Organisation_code,
          source_system,
          Hostname_IP,
        });
      }
      setOpenEditConnectionDrawer(true);
    };

    if (connectionDetailTableData.length >= 1) {
      return connectionDetailTableData.map((tableData, index) => {
        const {
          Port = "",
          access_token = "",
          company_code = "",
          Organisation_code = "",
          Hostname_IP = "",
          Username = "",
          Password = "",
          Company = "",
          License_Key = "",
          client_id = "",
          client_secret = "",
          organisation_id = "",
          code = "",
          name = "",
        } = tableData.connection_info || {};
        const { domain = ".in", auto_sync, from_date, to_date } = tableData;

        return (
          <tr key={index}>
            <td>{tableData.source_system}</td>
            <td>
              {tableData.source_system === "IARS" ? (
                <>{Company}</>
              ) : tableData.source_system === "ZOHO" ? (
                <div title="name">{name}</div>
              ) : (
                <>{company_code}</>
              )}
            </td>
            <td>
              {tableData.source_system === "IARS" ? (
                <>{Password}</>
              ) : tableData.source_system === "ZOHO" ? (
                <div title="organisation_id">{organisation_id}</div>
              ) : (
                <>{Organisation_code}</>

              )}
            </td>
            <td>{tableData.auto_sync ? "Yes" : "No"}</td>
            <td>{tableData.from_date ? new Date(tableData.from_date).toLocaleDateString("en-IN") : "-"}</td>
            <td>{tableData.to_date ? new Date(tableData.to_date).toLocaleDateString("en-IN") : "-"}</td>

            {tableData.source_system !== "ZOHO" && (
              <>
                <td>
                  {tableData.source_system === "IARS" ? (
                    <div title="Client_ID">{client_id}</div>
                  ) : (
                    <div title="Hostname_IP">{Hostname_IP}</div>
                  )}
                </td>
                <td>
                  {tableData.source_system === "IARS" ? (
                    <>{Username}</>
                  ) : (
                    <div title="Port">{Port}</div>
                  )}
                </td>
              </>
            )}

            <td>
              {tableData.source_system === "ZOHO" ? (
                <Button
                  size="small"
                  style={{
                    minWidth: "0px",
                    color: "#03406d",
                    textTransform: "none",
                    fontSize: "13px",
                    fontWeight: 600,
                    border: "1px solid #03406d",
                    borderRadius: "4px",
                    padding: "4px 10px",
                    whiteSpace: "nowrap"
                  }}
                  onClick={() =>
                    editConnectionData(
                      Port, access_token, company_code, Organisation_code,
                      tableData.source_system, Hostname_IP, Username, Password,
                      Company, License_Key, client_id, client_secret,
                      organisation_id, code, domain, auto_sync, from_date, to_date
                    )
                  }
                >
                  Auto Sync
                </Button>
              ) : (
                <Button
                  style={{ minWidth: "0px" }}
                  size="small"
                  onClick={() =>
                    editConnectionData(
                      Port, access_token, company_code, Organisation_code,
                      tableData.source_system, Hostname_IP, Username, Password,
                      Company, License_Key, client_id, client_secret,
                      organisation_id, code, domain, auto_sync, from_date, to_date
                    )
                  }
                >
                  <EditOutlinedIcon className="editIcon" style={{ color: "#03406d" }} />
                </Button>

              )}
            </td>
          </tr>



        );
      });
    } else {
      return (
        <tr>
          <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
            No Data found!
          </td>
        </tr>
      );
    }
  };

  // add connection section
  const openAddDrawer = () => {
    setOpenAddConnectionDrawer(true);
  };

  const addConnectionChangeHandler = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    if (value === "IARS") {
      setIarsFormToShowInAddConnection(true);
      setZohoFormToShowInAddConnection(false);
      setAddData({ ...addData, domain: undefined });
    } else if (value === "ZOHO") {
      setIarsFormToShowInAddConnection(false);
      setZohoFormToShowInAddConnection(true);
      setAddData({ ...addData, domain: ".in" });
    } else {
      setIarsFormToShowInAddConnection(false);
      setZohoFormToShowInAddConnection(false);
      setAddData({ ...addData, domain: undefined });
    }
    if (name === "source_system") {
      setAddSourceSystem(value);
    }
  };

  const addConnectionDomainChangeHandler = (event) => {
    const value = event.target.value;
    setAddData({
      ...addData,
      domain: String(value),
    });
  };

  const addConnectionChangeHandlerForIars = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setAddData({
      ...addData,
      [name]: String(value),
    });
  };

  const formatDateToYYYYMMDD = (date) => {
    if (!date) return null;

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const addConnectionSubmitHandler = () => {
    axios
      .post("/connectioninfo_post_api", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        source_system: addSourceSystem,
        domain: addData.domain,
        auto_sync: addData.auto_sync === "Yes",
        from_date: addData.from_date ? formatDateToYYYYMMDD(addData.from_date) : null,
        to_date: addData.to_date ? formatDateToYYYYMMDD(addData.to_date) : null,
        connection_info: {
          client_id: addData.client_id,
          client_secret: addData.client_secret,
          organisation_id: addData.organisation_id,
          code: addData.code,
          access_token: addData.access_token,
        },
      })
      .then((res) => {
        getConnectionDetails();
        setAddData({});
        setAddSourceSystem("");
        setOpenAddConnectionDrawer(false);
        toast.success("Added Successfully", {
          autoClose: 3000,
          progress: 0,
        });
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to add connection", {
          autoClose: 3000,
          progress: 0,
        });
        setOpenAddConnectionDrawer(false);
        setAddData({});
      });
  };

  const closeAddDrawer = () => {
    setOpenAddConnectionDrawer(false);
    setAddData({});
    setAddSourceSystem("");
    setIarsFormToShowInAddConnection(false);
    setZohoFormToShowInAddConnection(false);
  };

  const editConnectionChangeHandleForIars = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setTrueOrFalse(true);
    setTrueOrFalseForZoho(false);
    setEdiDataForIars({
      ...ediDataForIars,
      [name]: String(value),
    });
  };

  const editConnectionChangeHandleForZoho = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setTrueOrFalseForZoho(true);
    setTrueOrFalse(false);
    if (name === "auto_sync") {
      setEditDataForZoho({
        ...editDataForZoho,
        [name]: value,
        from_date: "",
        to_date: "",
      });
    } else {
      setEditDataForZoho({
        ...editDataForZoho,
        [name]: String(value),
      });
    }
  };

  const editConnectionChangeHandle = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setTrueOrFalseForZoho(false);
    setTrueOrFalse(false);
    setEditData({
      ...editData,
      [name]: String(value),
    });
  };

  const formatDateToDDMMYYYY = (date) => {
    if (!date) return null;

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const editConnectionSubmitHandler = () => {
    let json;
    if (trueOrFalse === true) {
      json = ediDataForIars;
    } else if (trueOrFalseForZoho === true) {
      json = { ...editDataForZoho, source_system: "ZOHO" };
    } else {
      json = editData;
    }

    if (json.source_system === "ZOHO") {
      axios
        .post("/update_autosync", {
          business_entity_id: localStorage.getItem("business_entity_id"),
          auto_sync: json.auto_sync === "Yes",
          from_date: json.from_date ? formatDateToYYYYMMDD(json.from_date) : null,
          to_date: json.to_date ? formatDateToYYYYMMDD(json.to_date) : null,
        })
        .then((res) => {
          getConnectionDetails();
          setEditData({});
          setEdiDataForIars({});
          setEditDataForZoho({});
          setTrueOrFalse(false);
          setTrueOrFalseForZoho(false);
          setOpenEditConnectionDrawer(false);
          toast.success("Updated Successfully", {
            autoClose: 3000,
            progress: 0,
          });
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Failed to update connection", {
            autoClose: 3000,
            progress: 0,
          });
          setTrueOrFalse(false);
          setTrueOrFalseForZoho(false);
          setOpenEditConnectionDrawer(false);
          setEditData({});
          setEdiDataForIars({});
          setEditDataForZoho({});
        });
      return;
    }
    axios
      .put("/connectioninfo_put_api", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        source_system: json.source_system,
        domain: json.domain,
        auto_sync: json.auto_sync === "Yes",
        from_date: json.from_date ? formatDateToYYYYMMDD(json.from_date) : null,
        to_date: json.to_date ? formatDateToYYYYMMDD(json.to_date) : null,
        connection_info: {
          client_id: json.client_id,
          client_secret: json.client_secret,
          organisation_id: json.organisation_id,
          code: json.code,
          access_token: json.access_token,
        },
      })
      .then((res) => {
        getConnectionDetails();
        setEditData({});
        setEdiDataForIars({});
        setEditDataForZoho({});
        setTrueOrFalse(false);
        setTrueOrFalseForZoho(false);
        setOpenEditConnectionDrawer(false);
        toast.success("Updated Successfully", {
          autoClose: 3000,
          progress: 0,
        });
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Failed to update connection", {
          autoClose: 3000,
          progress: 0,
        });
        setTrueOrFalse(false);
        setTrueOrFalseForZoho(false);
        setOpenEditConnectionDrawer(false);
        setEditData({});
        setEdiDataForIars({});
        setEditDataForZoho({});
      });
  };

  const closeEditDrawer = () => {
    setOpenEditConnectionDrawer(false);
    setEditData({});
    setEdiDataForIars({});
    setEditDataForZoho({});
    setTrueOrFalse(false);
    setTrueOrFalseForZoho(false);
  };

  const handleConnectionInfo = () => {
    console.log("Connection Info clicked");
    window.open('https://api-console.zoho.com/', '_blank');
  };

  return (
    <>
      <BoxWrapper
        boxTitle="Connection Details"
        enableAddButton={true}
        addButtonLabel={"ADD Connection Details"}
        addButtonHandlerFn={() => openAddDrawer()}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <tbody>
              {connectionDetailTableData.length === 0 ? (
                <>
                  <tr>
                    <th>Source System</th>
                    <th>Company Name</th>
                    <th>Organisation ID</th>
                    <th>Auto Sync</th>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Action</th>
                  </tr>
                  <tr>
                    <td colSpan={7} style={{ color: "red", textAlign: "center" }}>
                      No Data found!
                    </td>
                  </tr>
                </>
              ) : (
                (() => {
                  const zohoRows = connectionDetailTableData.filter(r => r.source_system === "ZOHO");
                  const iarsRows = connectionDetailTableData.filter(r => r.source_system === "IARS");
                  const otherRows = connectionDetailTableData.filter(
                    r => r.source_system !== "ZOHO" && r.source_system !== "IARS"
                  );

                  const renderRow = (tableData, index) => {
                    const {
                      Port = "", access_token = "", company_code = "",
                      Organisation_code = "", Hostname_IP = "", Username = "",
                      Password = "", Company = "", License_Key = "",
                      client_id = "", client_secret = "", organisation_id = "",
                      code = "", name = "",
                    } = tableData.connection_info || {};
                    const { domain = ".in", auto_sync, from_date, to_date } = tableData;

                    const editConnectionData = () => {
                      if (tableData.source_system === "IARS") {
                        setIarsFormToShowInEditConnection(true);
                        setZohoFormToShowInEditConnection(false);
                        setEdiDataForIars({
                          source_system: tableData.source_system,
                          Username, Password, Company, License_Key, Hostname_IP
                        });
                      } else if (tableData.source_system === "ZOHO") {
                        setZohoFormToShowInEditConnection(true);
                        setIarsFormToShowInEditConnection(false);
                        setEditDataForZoho({
                          source_system: tableData.source_system,
                          client_id, client_secret, organisation_id, code,
                          domain: domain || ".in",
                          auto_sync: auto_sync ? "Yes" : "No",
                          from_date: from_date ? new Date(from_date) : "",
                          to_date: to_date ? new Date(to_date) : ""
                        });
                      } else {
                        setIarsFormToShowInEditConnection(false);
                        setZohoFormToShowInEditConnection(false);
                        setEditData({
                          Port, access_token, company_code, Organisation_code,
                          source_system: tableData.source_system, Hostname_IP
                        });
                      }
                      setOpenEditConnectionDrawer(true);
                    };

                    if (tableData.source_system === "ZOHO") {
                      return (
                        <tr key={`zoho-${index}`}>
                          <td>{tableData.source_system}</td>
                          <td>{name}</td>
                          <td>{organisation_id}</td>
                          <td>{tableData.auto_sync ? "Yes" : "No"}</td>
                          <td>{tableData.from_date ? new Date(tableData.from_date).toLocaleDateString("en-IN") : "-"}</td>
                          <td>{tableData.to_date ? new Date(tableData.to_date).toLocaleDateString("en-IN") : "-"}</td>
                          <td>
                            <Button
                              size="small"
                              style={{
                                minWidth: "0px", color: "#03406d", textTransform: "none",
                                fontSize: "13px", fontWeight: 600, border: "1px solid #03406d",
                                borderRadius: "4px", padding: "4px 10px", whiteSpace: "nowrap"
                              }}
                              onClick={editConnectionData}
                            >
                              Auto Sync
                            </Button>
                          </td>
                        </tr>
                      );

                    } else if (tableData.source_system === "IARS") {
                      return (
                        <tr key={`iars-${index}`}>
                          <td>{tableData.source_system}</td>
                          <td>{Company}</td>
                          <td>{Hostname_IP}</td>
                          <td>{Username}</td>
                          <td>{Password ? "*".repeat(Password.length) : "-"}</td>
                          <td>{License_Key}</td>
                          <td>
                            <Button
                              style={{ minWidth: "0px", display: "inline-flex" }}
                              size="small"
                              onClick={editConnectionData}
                            >
                              <EditOutlinedIcon style={{ color: "#03406d", fontSize: "18px" }} />
                            </Button>
                          </td>
                        </tr>
                      );

                    } else {
                      return (
                        <tr key={`other-${index}`}>
                          <td>{tableData.source_system}</td>
                          <td>{company_code}</td>
                          <td>{Organisation_code}</td>
                          <td>{Hostname_IP}</td>
                          <td>{Port}</td>
                          <td>{access_token}</td>
                          <td>
                            <Button
                              style={{ minWidth: "0px", display: "inline-flex" }}
                              size="small"
                              onClick={editConnectionData}
                            >
                              <EditOutlinedIcon style={{ color: "#03406d", fontSize: "18px" }} />
                            </Button>
                          </td>
                        </tr>
                      );
                    }
                  };

                  return (
                    <>
                      {/* ZOHO section */}
                      {zohoRows.length > 0 && (
                        <>
                          <tr>
                            <th>Source System</th>
                            <th>Company Name</th>
                            <th>Organisation ID</th>
                            <th>Auto Sync</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Action</th>
                          </tr>
                          {zohoRows.map((row, i) => renderRow(row, i))}
                        </>
                      )}

                      {/* IARS section */}
                      {iarsRows.length > 0 && (
                        <>
                          <tr>
                            <th>Source System</th>
                            <th>Company Name</th>
                            <th>Hostname</th>
                            <th>Username</th>
                            <th>Password</th>
                            <th>License Key</th>
                            <th>Action</th>
                          </tr>
                          {iarsRows.map((row, i) => renderRow(row, i))}
                        </>
                      )}

                      {/* Tally / Other section */}
                      {otherRows.length > 0 && (
                        <>
                          <tr>
                            <th>Source System</th>
                            <th>Company Code</th>
                            <th>Organisation Code</th>
                            <th>Hostname/IP</th>
                            <th>Port</th>
                            <th>Access Token</th>
                            <th>Action</th>
                          </tr>
                          {otherRows.map((row, i) => renderRow(row, i))}
                        </>
                      )}
                    </>
                  );
                })()
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      {/* Add Connection Details Drawer */}
      <RightDrawer
        drawerName="Add Connection Details"
        open={openAddConnectionDrawer}
        onClose={closeAddDrawer}
      >
        <ValidatorForm
          ref={formRef}
          onSubmit={addConnectionSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          <SelectField
            SelectLabel="Source System"
            choice_id="source_system"
            choice_name="source_system"
            name="source_system"
            requiredField="*"
            validator={["required"]}
            errorMsg={["This field is required"]}
            value={addSourceSystem ?? ""}
            choices={[
              // { id: "Effitrac", source_system: "Effitrac" },
              { id: "Tally", source_system: "Tally" },
              { id: "IARS", source_system: "IARS" },
              { id: "ZOHO", source_system: "ZOHO" },
            ]}
            textOnchangeFunction={addConnectionChangeHandler}
          />

          {iarsFormToShowInAddConnection ? (
            <div>
              <InputField
                inputType="text"
                textLabel="Hostname"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                name="Hostname_IP"
                value={addData.Hostname_IP ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="User Name"
                name="Username"
                value={addData.Username ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Password"
                name="Password"
                value={addData.Password ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Company"
                name="Company"
                value={addData.Company ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="License Key"
                name="License_Key"
                value={addData.License_Key ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
            </div>
          ) : zohoFormToShowInAddConnection ? (
            <div>
              <div style={{ marginTop: "16px", marginBottom: "16px" }}>
                <Button
                  variant="contained"
                  onClick={handleEstablishConnection}
                  fullWidth
                  style={{
                    backgroundColor: "#03406d",
                    color: "#fff",
                    textTransform: "none",
                  }}
                >
                  Establish Connection
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <InputField
                inputType="text"
                textLabel="Hostname"
                name="Hostname_IP"
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                value={addData.Hostname_IP ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Port"
                name="Port"
                value={addData.Port ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Company Code"
                name="company_code"
                value={addData.company_code ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Organisation Code"
                name="Organisation_code"
                value={addData.Organisation_code ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
              <InputField
                inputType="text"
                textLabel="Access Token"
                name="access_token"
                value={addData.access_token ?? ""}
                textOnchangeFunction={addConnectionChangeHandlerForIars}
              />
            </div>
          )}

          <div className="mt-20">
            {!zohoFormToShowInAddConnection && (
              <button className="button-primary" type="submit">
                Submit
              </button>
            )}
            <button
              type="button"
              className="button-outlined-secondary"
              onClick={closeAddDrawer}
            >
              Cancel
            </button>
          </div>
        </ValidatorForm>
      </RightDrawer>

      {/* Edit Connection Details Drawer */}
      <RightDrawer
        drawerName="Edit Connection Details"
        open={openEditConnectionDrawer}
        onClose={closeEditDrawer}
      >
        <ValidatorForm
          ref={formRef}
          onSubmit={editConnectionSubmitHandler}
          onError={(errors) => console.log(errors)}
        >
          {iarsFormToShowInEditConnection ? (
            <div>
              {/* Source System - read only */}
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", color: "#666" }}>Source System</label>
                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5", color: "#333" }}>
                  {ediDataForIars.source_system}
                </div>
              </div>
              <InputField inputType="text" textLabel="Hostname" requiredField="*" validator={["required"]} errorMsg={["This field is required"]} name="Hostname_IP" value={ediDataForIars.Hostname_IP ?? ""} textOnchangeFunction={editConnectionChangeHandleForIars} />
              <InputField inputType="text" textLabel="User Name" name="Username" value={ediDataForIars.Username ?? ""} textOnchangeFunction={editConnectionChangeHandleForIars} />
              <InputField inputType="text" textLabel="Password" name="Password" value={ediDataForIars.Password ?? ""} textOnchangeFunction={editConnectionChangeHandleForIars} />
              <InputField inputType="text" textLabel="Company" name="Company" value={ediDataForIars.Company ?? ""} textOnchangeFunction={editConnectionChangeHandleForIars} />
              <InputField inputType="text" textLabel="License Key" name="License_Key" value={ediDataForIars.License_Key ?? ""} textOnchangeFunction={editConnectionChangeHandleForIars} />
            </div>

          ) : zohoFormToShowInEditConnection ? (
            <div>
              {/* Source System - read only label */}
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", color: "#666" }}>Source System</label>
                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5", color: "#333" }}>
                  ZOHO
                </div>
              </div>

              {/* Domain - read only label */}
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", color: "#666" }}>Domain</label>
                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5", color: "#333" }}>
                  {editDataForZoho.domain || ".in"}
                </div>
              </div>

              {/* Organisation ID - read only label */}
              <div style={{ marginBottom: "16px" }}>
                <label style={{ fontSize: "12px", color: "#666" }}>Organisation ID</label>
                <div style={{ padding: "10px", border: "1px solid #ddd", borderRadius: "4px", backgroundColor: "#f5f5f5", color: "#333" }}>
                  {editDataForZoho.organisation_id || "-"}
                </div>
              </div>

              {/* Zoho Auto Sync - editable */}
              <SelectField
                requiredField="*"
                validator={["required"]}
                errorMsg={["This field is required"]}
                SelectLabel="Zoho Auto Sync"
                choice_id="id"
                choice_name="auto_sync"
                name="auto_sync"
                value={editDataForZoho.auto_sync ?? "No"}
                textOnchangeFunction={editConnectionChangeHandleForZoho}
                choices={[
                  { id: "Yes", auto_sync: "Yes" },
                  { id: "No", auto_sync: "No" },
                ]}
              />

              {editDataForZoho.auto_sync === "Yes" && (
                <>
                  <div style={{ marginTop: "10px" }}>
                    <label>
                      From Date<span style={{ color: "red" }}>*</span>:
                    </label>
                    <ValidatedDatePicker
                      fullWidth
                      name="from_date"
                      value={editDataForZoho.from_date ?? ""}
                      onChange={(date) => {
                        editConnectionChangeHandleForZoho({
                          target: { name: "from_date", value: date }
                        });
                      }}
                      validators={["required"]}
                      errorMessages={["This field is required"]}
                    />
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <label>
                      To Date<span style={{ color: "red" }}>*</span>:
                    </label>
                    <ValidatedDatePicker
                      fullWidth
                      name="to_date"
                      value={editDataForZoho.to_date ?? ""}
                      onChange={(date) => {
                        editConnectionChangeHandleForZoho({
                          target: { name: "to_date", value: date }
                        });
                      }}
                      validators={["required"]}
                      errorMessages={["This field is required"]}
                    />
                  </div>
                </>
              )}
            </div>

          ) : (
            <div>
              <SelectField
                SelectLabel="Source System"
                choice_id="id"
                choice_name="source_system"
                name="source_system"
                value={editData.source_system ?? ""}
                inputProps={{ readOnly: true }}
                choices={[
                  { id: "Effitrac", source_system: "Effitrac" },
                  { id: "Tally", source_system: "Tally" },
                  { id: "IARS", source_system: "IARS" },
                ]}
              />
              <InputField inputType="text" textLabel="Hostname" name="Hostname_IP" value={editData.Hostname_IP ?? ""} textOnchangeFunction={editConnectionChangeHandle} />
              <InputField inputType="text" textLabel="Port" name="Port" value={editData.Port ?? ""} textOnchangeFunction={editConnectionChangeHandle} />
              <InputField inputType="text" textLabel="Company Code" name="company_code" value={editData.company_code ?? ""} textOnchangeFunction={editConnectionChangeHandle} />
              <InputField inputType="text" textLabel="Organisation Code" name="Organisation_code" value={editData.Organisation_code ?? ""} textOnchangeFunction={editConnectionChangeHandle} />
              <InputField inputType="text" textLabel="Access Token" name="access_token" value={editData.access_token ?? ""} textOnchangeFunction={editConnectionChangeHandle} />
            </div>
          )}

          <div className="mt-20">
            <button className="button-primary" type="submit">Submit</button>
            <button type="button" className="button-outlined-secondary" onClick={closeEditDrawer}>Cancel</button>
          </div>
        </ValidatorForm>
      </RightDrawer>
    </>
  );
};

export default ConnectionDetails;